<template>
      <div class="custom-category-icon-container">
            <!--<font-awesome-icon v-bind:class="getTopIconClass" :size="topIconSize"  icon="heart"/>
            <font-awesome-icon class="custom-category-icon custom-category-icon-bottom" :size="bottomIconSize"  icon="hands"/>-->
            <img class="mx-auto icon-img" src="../../assets/Group_20.png" alt="Group_20"/>
      </div>
</template>

<script>
export default {
    name: "HandHoldingHeart",
    props: ['bottomIconSize', 'topIconSize', 'iconStyle'],
    //computed: {
    //    getTopIconClass: function() {
    //        return this.iconStyle == 'large' ? 'custom-category-icon custom-category-icon-top large-icon' : 'custom-category-icon custom-category-icon-top small-icon';
    //    }
    //}
}
</script>

<style scoped>

</style>